/*
  Novelissa · piezas de venta propias (02/10/2026), sin apps de pago.
  - Fecha de llegada en la ficha: hoy + días hábiles que fija Adam (5-8).
  - Carrito: aviso del segundo bolso al 30 % y neceser del mismo color.
  - Colores de la ficha con la foto del propio bolso cuando la variante la tiene.
  Solo promete lo que existe: si falta un dato, la pieza no se pinta.
*/
(() => {
  if (window.nv3VentasIniciadas) return;
  window.nv3VentasIniciadas = true;
  const raiz = window.Shopify?.routes?.root || '/';

  /* ---------- Fecha de llegada ---------- */
  const sumarHabiles = (desde, dias) => {
    const fecha = new Date(desde);
    let quedan = dias;
    while (quedan > 0) {
      fecha.setDate(fecha.getDate() + 1);
      const dia = fecha.getDay();
      if (dia !== 0 && dia !== 6) quedan -= 1;
    }
    return fecha;
  };
  const formato = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
  const pintarLlegada = () => {
    document.querySelectorAll('[data-nv3-llegada]').forEach((nodo) => {
      const minimo = Number(nodo.dataset.min);
      const maximo = Number(nodo.dataset.max);
      if (!minimo || !maximo) return;
      const hoy = new Date();
      const desde = formato.format(sumarHabiles(hoy, minimo));
      const hasta = formato.format(sumarHabiles(hoy, maximo));
      nodo.textContent = `${nodo.dataset.prefijo} ${desde}–${hasta}`;
    });
  };

  /* ---------- Colores con foto del bolso ---------- */
  const pintarMuestras = () => {
    const datos = document.querySelector('[data-nv3-muestras]');
    if (!datos) return;
    let imagenes;
    try { imagenes = JSON.parse(datos.textContent); } catch { return; }
    document.querySelectorAll('variant-selects input[type="radio"]').forEach((entrada) => {
      const url = imagenes[entrada.value];
      const etiqueta = entrada.id && document.querySelector(`label[for="${CSS.escape(entrada.id)}"]`);
      if (!url || !etiqueta || etiqueta.querySelector('.nv3-muestra')) return;
      const foto = document.createElement('img');
      foto.className = 'nv3-muestra';
      foto.src = url;
      foto.alt = '';
      foto.width = 44;
      foto.height = 44;
      foto.loading = 'lazy';
      etiqueta.classList.add('nv3-con-muestra');
      etiqueta.prepend(foto);
    });
  };

  /* ---------- Carrito: segundo bolso y neceser ---------- */
  const leerConfig = () => {
    const nodo = document.getElementById('nv3-ventas-config');
    if (!nodo) return null;
    try { return JSON.parse(nodo.textContent); } catch { return null; }
  };
  const config = leerConfig();
  let ultimoCarrito = null;

  const bolsosEn = (carrito) => carrito.items
    .filter((linea) => linea.product_type === config.tipoBolso)
    .reduce((total, linea) => total + linea.quantity, 0);

  const colorDe = (linea) => (linea.options_with_values || []).find((o) => /colou?r/i.test(o.name))?.value;

  const htmlCarrito = (carrito) => {
    if (!config) return '';
    const bolsos = bolsosEn(carrito);
    let html = '';
    if (config.segundoBolso && bolsos === 1) {
      html += `<p class="nv3-vn__aviso">Add a second bag and it’s <strong>30% off</strong>. <a href="${config.urlColeccion}">Shop the edit</a></p>`;
    } else if (config.segundoBolso && bolsos >= 2) {
      html += '<p class="nv3-vn__aviso">Your second bag is <strong>30% off</strong>, applied at checkout.</p>';
    }
    const pouch = config.neceser;
    const tieneNeceser = carrito.items.some((linea) => linea.handle === pouch?.handle);
    if (pouch && bolsos >= 1 && !tieneNeceser) {
      const bolso = carrito.items.find((linea) => linea.product_type === config.tipoBolso);
      const color = bolso && colorDe(bolso);
      const variante = pouch.variantes.find((v) => v.color === color && v.disponible)
        || pouch.variantes.find((v) => v.disponible);
      if (variante) {
        html += `<div class="nv3-vn__up">
          ${variante.imagen ? `<img src="${variante.imagen}" alt="" width="56" height="56" loading="lazy">` : ''}
          <span class="nv3-vn__up-info"><span class="nv3-vn__up-name">${pouch.titulo} · ${variante.color || ''}</span>
          <span class="nv3-vn__up-why">${pouch.motivo}</span></span>
          <button type="button" class="nv3-vn__up-add" data-nv3-anadir="${variante.id}">Add ${variante.precio}</button>
        </div>`;
      }
    }
    return html;
  };

  const pintarCarrito = () => {
    if (!ultimoCarrito) return;
    const html = htmlCarrito(ultimoCarrito);
    document.querySelectorAll('cart-drawer .cart__ctas, #main-cart-footer .cart__ctas').forEach((destino) => {
      let caja = destino.parentElement.querySelector('[data-nv3-vn]');
      if (!html) { caja?.remove(); return; }
      if (!caja) {
        caja = document.createElement('div');
        caja.className = 'nv3-vn';
        caja.dataset.nv3Vn = '';
        destino.insertAdjacentElement('beforebegin', caja);
      }
      if (caja.innerHTML !== html) caja.innerHTML = html;
    });
  };

  const refrescarCarrito = async () => {
    try {
      const respuesta = await fetch(`${raiz}cart.js`, { signal: AbortSignal.timeout(10000) });
      if (!respuesta.ok) return;
      ultimoCarrito = await respuesta.json();
      pintarCarrito();
    } catch { /* Sin carrito leído no se promete nada. */ }
  };

  document.addEventListener('click', async (evento) => {
    const boton = evento.target.closest('[data-nv3-anadir]');
    if (!boton) return;
    boton.disabled = true;
    const cajon = document.querySelector('cart-drawer');
    try {
      const respuesta = await fetch(`${raiz}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(boton.dataset.nv3Anadir), quantity: 1 }],
          sections: cajon ? 'cart-drawer,cart-icon-bubble' : undefined,
        }),
      });
      if (!respuesta.ok) throw new Error('No se pudo añadir');
      const estado = await respuesta.json();
      if (cajon?.renderContents && estado.sections) cajon.renderContents({ ...estado, id: estado.items?.[0]?.variant_id ?? estado.id });
      else window.location.reload();
      refrescarCarrito();
    } catch {
      boton.disabled = false;
      boton.textContent = 'Try again';
    }
  });

  const arrancar = () => {
    pintarLlegada();
    pintarMuestras();
    if (!config) return;
    refrescarCarrito();
    const observador = new MutationObserver((cambios) => {
      if (cambios.some((c) => !c.target.closest?.('[data-nv3-vn]'))) {
        clearTimeout(observador.espera);
        observador.espera = setTimeout(refrescarCarrito, 150);
      }
    });
    document.querySelectorAll('cart-drawer, #main-cart-footer').forEach((nodo) => observador.observe(nodo, { childList: true, subtree: true }));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
